import React from 'react'

import { Container } from './grid'

import styles from './footer.module.css'

const Footer = () => (
  <footer className={styles.footer}>
    <Container>
      <div className={styles.flex}>
        <ul className={styles.list}>
          <li>
            <a href="https://twitter.com/unslant">Twitter</a>
          </li>
          <li>
            <a href="https://github.com/unslant/unslant">Issue Tracker</a>
          </li>
          <li>
            <a href="https://www.notion.so/unslant/Outlets-5d5a80e30d584f189c7049948e7ce628">
              Supported Outlets
            </a>
          </li>
        </ul>
        <p>
          Made by <a href="https://kabirgoel.com">Kabir Goel</a>.
        </p>
      </div>
    </Container>
  </footer>
)

export default Footer
